import React, { useState,ReactNode } from "react";

const themes = {
    light: {
      foreground: "#000000",
      background: "#eeeeee"
    },
    dark: {
      foreground: "#ffffff",
      background: "#222222"
    }
  };
interface AppProviderRrops {
    children?: ReactNode
}
export const ThemeContext = React.createContext(themes.light);
export const ThemeUpdate = React.createContext(function changeTheme(){});
export const AppProvider = (props:AppProviderRrops) => {
    const [theme,setTheme] = useState(themes.dark);
    const changeTheme = ()=>{
        console.log('AppProvider changeTheme');
        setTheme(theme);
    }

    return (<ThemeContext.Provider value={themes.light}>
              <ThemeUpdate.Provider value={changeTheme}>
                  {props.children}
              </ThemeUpdate.Provider>
          </ThemeContext.Provider>)
}